import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore, enableNetwork, disableNetwork } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBcqEAiaK-OdsSUDfL66zIzNzu7-MXiuDk",
  authDomain: "barino-871b8.firebaseapp.com",
  projectId: "barino-871b8",
  storageBucket: "barino-871b8.appspot.com",
  messagingSenderId: "774954906869",
  appId: "1:774954906869:web:20f3665be34113e31a81bc",
  measurementId: "G-GVGWY77CCC"

};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Google Auth Provider
export const googleProvider = new GoogleAuthProvider();

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Enable network and disable offline persistence to always get fresh data
if (typeof window !== 'undefined') {
  enableNetwork(db).catch(console.error);
}

// Initialize Firebase Storage and get a reference to the service
export const storage = getStorage(app);

export default app; 